import { createSelector } from 'reselect'

/**
 * @deprecated
 */
const selectPackageTypesById = (state) => state.resources.PackageTypesReducer.byId

/**
 * @deprecated
 */
export const selectPackageType = (typeId) =>
  createSelector([selectPackageTypesById], (byId = {}) => byId[typeId])
